import React from "react";
import PublicNavbar from "../../components/public/PublicNavbar";

const RefundPolicy = () => {
    return (
        <div className="min-h-screen bg-[#FFFFFF] text-[#263746] font-sans">
            <PublicNavbar />

            <div className="bg-[#F7F5EF] border-b border-[#E5E7EB] py-12 px-6 text-center">
                <div className="max-w-4xl mx-auto">
                    <span className="text-[#E3B629] text-xs font-black tracking-[0.25em] uppercase block mb-1">
                        Commercial Policy
                    </span>
                    <h1 className="text-3xl sm:text-4xl font-extrabold text-[#263746]">
                        Returns, Refunds & Cancellation Policy
                    </h1>
                    <p className="text-[#687482] text-xs sm:text-sm mt-2">
                        LUMIGO PROJECTION SOLUTIONS • Fourlifters Private Limited • Commercial Equipment Terms
                    </p>
                </div>
            </div>

            <div className="max-w-4xl mx-auto px-6 py-12 space-y-8 text-[#687482] text-xs sm:text-sm leading-relaxed">
                <section className="space-y-3">
                    <h2 className="text-base font-bold text-[#263746] uppercase tracking-wider">
                        1. Custom Laser-Etched Glass Gobos
                    </h2>
                    <p>
                        Custom dichroic glass gobos and personalized optical discs are manufactured strictly to client-submitted vector artwork, dimensions, and specifications. Once laser etching begins following client proof approval, custom gobo orders cannot be cancelled, refunded, or returned for change of mind.
                    </p>
                </section>

                <section className="space-y-3">
                    <h2 className="text-base font-bold text-[#263746] uppercase tracking-wider">
                        2. Projector Hardware Cancellation Prior to Dispatch
                    </h2>
                    <p>
                        Order cancellations for standard projector hardware must be submitted in writing prior to physical consignment dispatch. If approved by management, any applicable refund is processed offline via original banking channels less direct processing or handling costs.
                    </p>
                </section>

                <section className="space-y-3">
                    <h2 className="text-base font-bold text-[#263746] uppercase tracking-wider">
                        3. In-Transit Damage & Delivery Discrepancies
                    </h2>
                    <p>
                        Clients are advised to inspect the exterior shipping package upon delivery before signing the courier acknowledgment. If physical transit damage is evident:
                    </p>
                    <ul className="list-disc list-inside space-y-1 text-[#687482]">
                        <li>Photograph the unopened exterior carton and courier AWB label immediately.</li>
                        <li>Notify LUMIGO within 48 hours of delivery at fourlifters@gmail.com / sales@fourlifters.in or via WhatsApp at +91 8087680893.</li>
                        <li>Retain all original packaging materials for courier inspection.</li>
                    </ul>
                </section>

                <section className="space-y-3">
                    <h2 className="text-base font-bold text-[#263746] uppercase tracking-wider">
                        4. Technical DOA (Dead on Arrival) & Replacement
                    </h2>
                    <p>
                        If a projector hardware unit exhibits a verified manufacturing defect upon initial installation and bench testing, Fourlifters Private Limited will provide repair, replacement components, or unit replacement in accordance with the product warranty schedule.
                    </p>
                </section>

                <section className="space-y-3">
                    <h2 className="text-base font-bold text-[#263746] uppercase tracking-wider">
                        5. Support Desk
                    </h2>
                    <p className="font-semibold text-xs text-[#263746] leading-relaxed">
                        Fourlifters Private Limited (Brand: LUMIGO)<br />
                        E-21/22, Kaygee Engineering Premises, T Block, MIDC Bhosari, Pune, Maharashtra - 411026<br />
                        Email: fourlifters@gmail.com / sales@fourlifters.in | WhatsApp: +91 8087680893
                    </p>
                </section>
            </div>
        </div>
    );
};

export default RefundPolicy;
